import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BigCard from "../../../general/BigCard";
import PieGraph from "../../../general/PieGraph";
import Leaflet from "./maps/LeafletMap";
import styles from "./SocialL2.module.css";

function SocialL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);
  const [rendaPrincipal, setRendaPrincipal] = useState(null);
  const [dificuldade, setDificuldade] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [numeroPropriedades, areaMedia, rendaPrincipal, dificuldade] = await Promise.all([
          Api.getNumeroPropriedades2(
            distrito,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
          ),
          Api.getAreaMediaDistrito(distrito),
          Api.getRendaPrincipalRural(distrito),
          Api.getMaiorDificuldade(distrito)
        ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
        setRendaPrincipal(Functions.buildSmallPieGraphParams(rendaPrincipal));
        setDificuldade(Functions.buildPieGraphParams2(dificuldade));
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  const mockupFunction = (value) => {
    value = value + 1;
  };

  return (
    <div className={styles.socialL2}>
      <div className={styles.cards}>
        <div className={styles.bigCard}>
          <BigCard name="Propriedades" value={numeroPropriedades?.value} />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={areaMedia?.value?.toFixed(2)}
          />
        </div>
      </div>

      <div className={styles.map}>
        <Leaflet distrito={distrito} />
      </div>

      <div className={styles.barGraph}>
        <div className={styles.pieGraph}>
          { rendaPrincipal && (
          <PieGraph
            data={rendaPrincipal}
            text="RENDA PRINCIPAL RURAL"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />)}
        </div>
        <div className={styles.pieGraph}>
          { dificuldade && (
          <PieGraph
            data={dificuldade}
            text="MAIOR DIFICULDADE"
            onLegendClick={mockupFunction}
            currentValue={null}
            oldValue={null}
            onOldValue={mockupFunction}
            onImageReady={mockupFunction}
          />
          )}
        </div>
      </div>
    </div>
  );
}

export default SocialL2;
